import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import { useEffect } from "react";

import liff from "@line/liff";
import { VERSION_APP } from "./Utills/constants";

import { gachaConfigs } from "./Configs/configs";
import ThemeMain from "./Components/Main/Theme";
import NotFound from "./Components/Main/NotFound";

function App() {

  useEffect(() => {
    document.title = `สุ่มกาชาปอง 99฿ ลุ้นรางวัลใหญ่ (v${VERSION_APP})`;
  }, []);

  useEffect(() => {

    liff.ready.then(() => {

    });
  }, []);
  return (
    <Router>
      <Routes>
        {gachaConfigs.map((config) => (
          <Route
            key={config.id}
            path={`/${config.name}`}
            element={<ThemeMain config={config} />}
          />
        ))}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
